import React from 'react';

interface SummaryItemRowProps {
    name: string;
    amount: number | string;
    sign?: string;
    bold?: boolean;
}

const SummaryItemRow: React.FC<SummaryItemRowProps> = ({ name, amount, sign, bold }) => (
    <div className={`summary-item-row${bold ? ' bold' : ''}`}>
        <p>{name}</p>
        <p>{sign ?? ''}${amount}</p>
    </div>
);

export default SummaryItemRow;